// 子仓库 - 商务管理
import to from 'await-to-js';
import * as apis from "@/api/interface/business";

const SESSION_KEY = 'business_policy_query_key';

export default {
  namespaced: true,
  state: () => ({
    queryKey: sessionStorage.getItem(SESSION_KEY) || '', // 任务key值，驱动下载按钮显示
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 保单批量上传
    async uploadTask(ctx, payload = {}) {
      const [, res] = await to(apis.businessPolicyUploadTask(payload));
      // A接口返回的 data 为 key 值，同步更新 state 和 sessionStorage
      if (res && res.code === '000000' && res.data) {
        sessionStorage.setItem(SESSION_KEY, res.data);
        ctx.commit('update', { queryKey: res.data });
      }
      return res;
    },
    // 获取任务状态
    async getTaskStatus(_ctx, payload = {}) {
      const [, res] = await to(apis.businessPolicyGetTaskStatus(payload));
      return res;
    },
    // 下载任务结果
    async downTaskResult(_ctx, payload = {}) {
      const [, res] = await to(apis.businessPolicyDownTaskResult(payload));
      return res;
    },
  },
  modules: {},
};
